import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { SeoMeta } from './components/SeoMeta';
import { ServiceDetail } from './components/ServiceDetail';
import { LegalPage } from './components/LegalPage';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { Contact } from './pages/Contact';
import { NotFound } from './pages/NotFound';
import { services } from './data/services';
import { legalPages } from './data/legal';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2wjgqzi86lvgf">
      <ScrollToTop data-id="element-1" data-mp="2wiyxgtcwlvc7" />
      <SeoMeta data-id="element-2" data-mp="2wifgpfyzpczr" />
      <div className="flex min-h-screen w-full flex-col bg-white" data-id="element-3" data-mp="2whx95n6vnccj">
        <Header data-id="element-4" data-mp="28t4lee0esat0" />
        <main className="flex-1" data-id="element-5" data-mp="28sl3gxardmez">
          <Routes data-id="element-6" data-mp="23vcikoy874a1">
            <Route path="/" element={<Home data-id="element-8" data-mp="23ujjma5idj2g" />} data-id="element-7" data-mp="23vul23bheeqe" />
            <Route path="/about" element={<About data-id="element-10" data-mp="3ijxsgzk2wgo4" />} data-id="element-9" data-mp="23v2uj6wqr76z" />
            <Route path="/services" element={<Services data-id="element-12" data-mp="3ijfunyhrpue3" />} data-id="element-11" data-mp="3ikqyfyb7r257" />
            {services.map(service => <Route key={service.slug} path={service.path} element={<ServiceDetail service={service} data-id="element-14" data-mp="3rdapodp6e4g0" />} data-id="element-13" data-mp="3mkrgru1fnxhj" />)}
            <Route path="/contact" element={<Contact data-id="element-16" data-mp="4n6o4eeqtbm" />} data-id="element-15" data-mp="6hp9c27i9cj" />
            {legalPages.map(page => <Route key={page.path} path={page.path} element={<LegalPage content={page} data-id="element-18" data-mp="33m5a7zn5de68" />} data-id="element-17" data-mp="2zllcouynw8jk" />)}
            <Route path="*" element={<NotFound data-id="element-20" data-mp="38l8j5v6904jh" />} data-id="element-19" data-mp="33ohzyyz5cstu" />
          </Routes>
        </main>
        <Footer data-id="element-21" data-mp="38nuqbtp88i16" />
      </div>
    </BrowserRouter>;
}